import React, { Component } from 'react';

import { Subnav } from '../subnav';
import LicensesTable from './LicensesTable';
import { Button } from '../shared/Button';
import { confirm } from '../shared/ConfirmModal';

import StripeApi from '../../api/stripe';

import axios from 'axios';

class LicenseManager extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isLoading: false,
      customer: null,
      isPayer: false,
      group: null,
      initialLicenses: 0,
      annualLicenses: 0,
      initialTotal: 0,
      annualTotal: 0,
      dataChange: false,
      isbusy: false,
      payerNotSet: false,
    };

    this.handleLicenseChange = this.handleLicenseChange.bind(this);
    this.handleButton = this.handleButton.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  signal = axios.CancelToken.source();

  async handleCancel() {
    const confirmed = await confirm({
      text: `You are choosing to cancel your subscription and lose access to PCMHGuide. To undo this action you will need to contact us at info@evolutionaryhealthsolutions.com. Are you sure?`
    });
    if (!confirmed) {
      return;
    }
    console.log("Cancelling");
    try {
      await StripeApi.handleCancellation();
    } catch (e) {
      alert("There was an error. Please contact info@evolutionaryhealthsolutions.com");
      return;
    }
    alert("Your subscription has been cancelled. It will remain active until the end of your period.")

  }
  async componentDidMount() {

    let customer = this.state.customer;
    try {
      customer = await StripeApi.getCustomer(this.signal.token);
      this.setState(
        {
          customer: customer.data,
        },
        () => {
          const { customer } = this.state;
          const group = { id: customer.id, purchaser: customer.purchaser };

          customer.subscriptions.data.forEach(sub => {
            if (sub.plan.nickname === 'Annual') {
              group['annual_licenses'] = sub.quantity;
              group['annual_cost'] = sub.plan.amount / 100;
            } else {
              group['initial_licenses'] = sub.quantity;
              group['initial_cost'] = sub.plan.amount / 100;
            }
          });

          this.setState({ group }, () => {
            const { group } = this.state;
            this.setState({
              initialLicenses: group.initial_licenses,
              annualLicenses: group.annual_licenses,
              initialTotal: group.initial_licenses * group.initial_cost,
              annualTotal: group.annual_licenses * group.annual_cost,
            });
          });
        }
      );
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log(err.message);
      } else {
        this.setState({ payerNotSet: true });
        console.log(err);
      }
    }
  }

  componentWillUnmount() {
    this.signal.cancel('Api is being cleared');
  }

  componentWillReceiveProps(nextProps) {
    const { isPayer } = nextProps;
    this.setState({ isPayer });
  }

  handleButton(bool) {
    this.setState({
      dataChange: bool,
    });
  }

  handleLicenseChange(evt) {
    const { group } = this.state;
    const { name, value } = evt.target;
    this.setState(
      {
        [name]: +value,
      },
      () => {
        if (name === 'initialLicenses') {
          this.setState({ initialTotal: value * group.initial_cost });
        } else {
          this.setState({ annualTotal: value * group.annual_cost });
        }
        if (
          this.state.initialLicenses !== group.initial_licenses ||
          this.state.annualLicenses !== group.annual_licenses
        ) {
          this.handleButton(true);
        } else {
          this.handleButton(false);
        }
      }
    );
  }

  async handleSubmit() {
    const {
      group,
      customer,
      initialLicenses,
      annualLicenses,
      initialTotal,
      annualTotal,
    } = this.state;
    const confirmed = await confirm({
      text: `This will change the amounts your group is charged to $${initialTotal}/month and $${annualTotal}/year. Are you sure you want to proceed?`,
    });
    if (!confirmed) {
      return;
    } else {
      this.setState({ isbusy: true });
      customer.subscriptions.data.forEach(async sub => {
        console.log(sub);

        if (sub.plan && sub.plan.nickname === 'Annual') {
          await StripeApi.updateSubscriptionCount('Annual', annualLicenses);
        } else if (sub.plan) {
          await StripeApi.updateSubscriptionCount('Initial', initialLicenses);
        } else {
          //look at items:
          if (sub.items && sub.items.data) {
            sub.items.data.forEach(async _sub => {
              if (_sub.plan && _sub.plan.nickname === 'Annual') {
                await StripeApi.updateSubscriptionCount('Annual', annualLicenses);
              } else if (_sub.plan) {
                await StripeApi.updateSubscriptionCount('Initial', initialLicenses);
              }
            })
          }
        }
      });
      const newGroup = Object.assign(group);
      newGroup.initial_licenses = initialLicenses;
      newGroup.annual_licenses = annualLicenses;
      this.setState({
        group: newGroup,
        isbusy: false,
      });
      this.handleButton(false);
    }
  }

  render() {
    const {
      isLoading,
      group,
      isPayer,
      initialLicenses,
      annualLicenses,
      initialTotal,
      annualTotal,
      dataChange,
      isbusy,
      payerNotSet,
    } = this.state;

    let content = (
      <div className="mainpage__content">
        <div>
          <i className="fa fa-circle-o-notch m2spin"></i>
          Loading Licenses Info
        </div>
      </div>
    );

    if (!isLoading && group) {
      content = (
        <div className="mainpage__content">
          <h2>Manage Group Licenses</h2>
          <LicensesTable
            group={group}
            initialLicenses={initialLicenses}
            annualLicenses={annualLicenses}
            initialTotal={initialTotal}
            annualTotal={annualTotal}
            isPayer={isPayer}
            handleLicenseChange={this.handleLicenseChange}
          />
          <div className="section__current-fees">
            <b>Current fees:</b>
            <div className="current-fees">
              <div>{`$${group.initial_licenses *
                group.initial_cost}/month`}</div>
              <div>{`$${group.annual_licenses * group.annual_cost}/year`}</div>
            </div>
          </div>
          <div className="section__current-fees">
            <b>Date of Purchase:</b>
            <div className="current-fees">
              <div>{`${new Date(this.state.purchaseDate)}`}</div>
            </div>
          </div>
          <div className="section__current-fees">
            <b>Auto-Renewal Date:</b>
            <div className="current-fees">
              <div>{`${new Date(this.state.renewalDate)}`}</div>
            </div>
          </div>
          {isPayer ? (
            <div className="form-buttons">
              <Button
                insufficientData={!dataChange}
                defaultText="Update Licenses"
                busyText="Updating"
                isbusy={isbusy}
                onClick={this.handleSubmit}
              />
            </div>

          ) : (
            <div>
              To update these subscriptions or the payment information, please
              contact your group's purchaser at{' '}
              <a href={`mailto:${group.purchaser}`}>{group.purchaser}</a>.
            </div>
          )}
        </div>
      );
    }

    if (payerNotSet) {
      content = (
        <div className="mainpage__content">
          <span>
            Your organization does not have a payer set up at this time. See
            your organization's administrator.
          </span>
        </div>
      );
    }

    return (
      <main className="page">
        <div className="page__subnav">
          <Subnav isPayer={isPayer} />
        </div>
        <div className="mainpage">{content}</div>
      </main>
    );
  }
}

export default LicenseManager;



// WEBPACK FOOTER //
// ./src/components/licenses/LicenseManager.js